import { render, staticRenderFns } from "./transfer-dialog.vue?vue&type=template&id=98d52028&scoped=true"
import script from "./transfer-dialog.vue?vue&type=script&lang=js"
export * from "./transfer-dialog.vue?vue&type=script&lang=js"
import style0 from "./transfer-dialog.vue?vue&type=style&index=0&id=98d52028&prod&lang=scss&scoped=true"
import style1 from "./transfer-dialog.vue?vue&type=style&index=1&id=98d52028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d52028",
  null
  
)

export default component.exports